module.exports = __webpack_public_path__ + "static/media/fu.3582bf9d.png";